import React from 'react';
import { BookOpen, ChevronRight } from 'lucide-react';
export function IncludesSection() {
  return <section className="w-full bg-gradient-to-br from-pink-100 via-rose-50 to-pink-200 py-16 px-4" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        <div className="text-center mb-12" data-id="element-104">
          <h2 className="text-4xl md:text-5xl font-black text-[#881337] uppercase tracking-wider mb-4" data-id="element-105">
            QUÉ INCLUYE
          </h2>
        </div>

        <div className="bg-white/60 backdrop-blur-md rounded-2xl p-8 md:p-12 border border-pink-200 shadow-2xl relative overflow-hidden" data-id="element-106">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 -mt-10 -mr-10 text-pink-300 opacity-20" data-id="element-107">
            <BookOpen size={200} data-id="element-108" />
          </div>

          <div className="relative z-10" data-id="element-109">
            <div className="flex items-center mb-6" data-id="element-110">
              <h3 className="text-2xl md:text-3xl font-bold text-[#881337]" data-id="element-111">
                Ebook principal:{' '}
                <span className="text-[#E9830F]" data-id="element-112">
                  Kit de Aprendizaje en Casa
                </span>
              </h3>
            </div>

            <div className="flex justify-center my-8" data-id="element-113">
              <img src="https://cdn.magicpatterns.com/uploads/jMe9PebJMC75b7ieG9xuXu/e1fda0d2-167e-43ef-b9fd-31ead329eb66.png" alt="Kit de Aprendizaje en Casa" className="w-64 md:w-80 h-auto object-contain drop-shadow-2xl" data-id="element-114" />
            </div>

            <p className="text-xl text-rose-900 mb-8 font-medium" data-id="element-115">
              Una guía psicopedagógica donde descubrirás:
            </p>

            <ul className="space-y-5 mb-10" data-id="element-116">
              {['por qué los niños se distraen fácilmente', 'cómo funciona el aprendizaje infantil', 'qué factores influyen en la concentración', 'cómo acompañar las tareas escolares sin conflictos', 'estrategias para estimular la motivación y el interés'].map((item, index) => <li key={index} className="flex items-start" data-id="element-117">
                  <ChevronRight className="h-6 w-6 text-[#E9830F] mr-3 flex-shrink-0 mt-0.5" data-id="element-118" />
                  <span className="text-lg md:text-xl text-gray-800" data-id="element-119">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="bg-pink-100/80 border border-pink-200 rounded-xl p-6 text-center" data-id="element-120">
              <p className="text-xl font-bold text-[#881337]" data-id="element-121">
                Un material claro y práctico para aplicar desde casa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}